import classNames from 'classnames';
import React from 'react';

import styles from './total-prices-placeholder.module.scss';

export const TotalPricesPlaceholder: React.FC = () => (
    <div className={styles.container}>
        <div className={classNames(styles.row, styles.titleRow)}>
            <div className={styles.text} />
            <div className={styles.price} />
        </div>
        <div className={styles.row}>
            <div className={styles.text} />
            <div className={styles.price} />
        </div>
    </div>
);
